// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ModalBackdrop_backdrop__1hWw8"};